import { useMemo } from 'react';
import { useTenant } from '../hooks/useTenant';
import {
  TENANT_CONFIG,
  getTenantConfig,
  getDefaults,
  generateShareContent,
  ShareContent,
} from '../utils/socialShareUtils';

export interface UseSocialShareOptions {
  type?: 'offer' | 'balance' | 'surveyComplete' | 'noTemplate';
  offer?: {
    title: string;
    url: string;
    paysReward: boolean;
    rewardLabel: string;
    advertiser: { name: string };
  };
  balance?: string;
  surveyComplete?: { amount: string };
  shareInfo?: {
    title?: string | null;
    description: string;
    url: string;
    imageUrl: string;
  };
}

export interface SocialShareData extends ShareContent {
  tenant: (typeof TENANT_CONFIG)[keyof typeof TENANT_CONFIG];
}

export const useSocialShare = (options: UseSocialShareOptions = {}) => {
  const tenant = useTenant();
  const currentTenant = getTenantConfig(tenant);

  const { type = 'noTemplate', offer, balance, surveyComplete, shareInfo } = options;

  const shareData: SocialShareData = useMemo(
    () => ({
      ...generateShareContent(
        type,
        currentTenant,
        getDefaults(currentTenant),
        offer,
        balance,
        surveyComplete,
        shareInfo,
      ),
      tenant: currentTenant,
    }),
    [type, currentTenant, offer, balance, surveyComplete, shareInfo],
  );

  return {
    shareData,
    tenant: currentTenant,
  };
};
